// extracted by mini-css-extract-plugin
export default {"kenoTablesWrap":"styles_kenoTablesWrap__Twvwk","kenoTableMyBetsWrap":"styles_kenoTableMyBetsWrap__Dxs+x"};